<template>
  <div>
    <van-popup v-model="show" round  
      :close-on-click-overlay="false" 
      :style="{ width: '80%' }"
      get-container="body"
    >
      <div class="content">
        <div class="title">退款待处理订单</div>
        <p class="text">
          您有
          <span class="order-color">{{info.waitRefundNum}}</span>
          笔“退款待处理”订单需处理请及时处理，超过
          <span class="order-color">{{info.autoRefundTime}}</span>
          小时未处理系统将自动同意订单退款。
        </p>
        <div class="btn-box">
          <div class="btn" @click="close">稍后处理</div>
          <div class="btn active" @click="handle">去处理</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['isRefundOrderPop'])
  },
  data() {
    return { 
      show: false,
      info: {}
    }
  },
  mounted() {
    if (this.isRefundOrderPop) {
      this.findRefundInfo()
    }
  },
  methods: {
    close() {
      this.show = false
      this.$store.commit('setRefundOrderPop', false)
    },
    handle() {
      this.close()
      this.$router.push({
        path: '/customer-list',
        query: {state: 5}
      })
    },
    findRefundInfo() {
      this.$api.customerList.findRefundInfo()
        .then(res => {
          if (res.success) {
            this.info = res.data
            if (res.data.waitRefundNum > 0) {
              this.show = true
            }
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    padding: 20px;
    .title {
      color: #333333;
      font-size: 17px;
      font-weight: bold;
      text-align: center;
    }
    .text {
      color: #333333;
      font-size: 15px;
      line-height: 24px;
      margin-top: 10px;
      .order-color {
        color: #FF8820;
      }
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .btn {
        width: 110px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        color: #666666;
        font-size: 14px;
        background: #E5E5E5;
        border-radius: 4px;
      }
      .active {
        color: #fff;
        background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%); 
      }
    }
  }
</style>